import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    backdrop: _ctx.backdrop,
    visible: _ctx.visible
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-lg font-bold" }, "Sei sicuro?")
      ], -1)
    ])),
    main: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, " Sei sicuro di procedere alla cancellazione del cliente? ", -1))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject'))),
            class: "col-start-3 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Chiudi ")
            ])),
            _: 1
          }),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
            class: "ml-4 py-2 px-4"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Sì ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _: 3
  }, 8, ["backdrop", "visible"]))
}